var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiujian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1806)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.479156,
    y: 7.03357,
    width: 4.04973,
    height: 0.966454,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5311,
    y: 7.03357,
    width: 2.02487,
    height: 0.966454,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.56619,
    y: 7.03357,
    width: 2.02487,
    height: 0.966454,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.496,
    y: 7.03357,
    width: 2.02487,
    height: 0.966454,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.00942,
    height: 15.5136,
    transform: "matrix(0.96881 0.247803 -0.270252 0.96279 7.65488 0.406738)",
    fill: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiujian);
export default __webpack_public_path__ + "static/media/xiujian.b6109e9958485a24764e6af087773b0c.svg";
export { ForwardRef as ReactComponent };